/*
 Template Name: Stexo - Responsive Bootstrap 4 Admin Dashboard
 Author: Themesdesign
 Website: www.themesdesign.in
 File: Main js
 */

!function($) {
  'use strict';

  var MainApp = function() {
    this.$body = $('body'),
      this.$wrapper = $('#wrapper'),
      this.$btnFullScreen = $('#btn-fullscreen'),
      this.$leftMenuButton = $('.button-menu-mobile'),
      this.$menuItem = $('.has_sub > a');
  };

  MainApp.prototype.initSlimscroll = function() {
    $('.slimscroll').slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      touchScrollStep: 50,
    });
  },

    MainApp.prototype.initNavbar = function() {

      $('.navbar-toggle').on('click', function(event) {
        $(this).toggleClass('open');
        $('#navigation').slideToggle(400);
      });

      $('.navigation-menu>li').slice(-1).addClass('last-elements');

      $('.navigation-menu li.has-submenu a[href="#"]').on('click', function(e) {
        if ($(window).width() < 992) {
          e.preventDefault();
          $(this).
            parent('li').
            toggleClass('open').
            find('.submenu:first').
            toggleClass('open');
        }
      });
    },

    MainApp.prototype.initActiveMenu = function() {
      $('.navigation-menu a').each(function() {
        let pageUrl = window.location.href.split(/[?#]/)[0];
        const params = _.get(window.location.href.split(/[?#]/), '1');

        if (params && params.includes('type=share'))
          pageUrl = window.location.href;

        if (this.href == pageUrl) {
          $(this).parent().addClass('active'); // add active to li of the current link
          $(this).parent().parent().parent().addClass('active'); // add active class to an anchor
          $(this).
            parent().
            parent().
            parent().
            parent().
            parent().
            addClass('active'); // add active class to an anchor
        }
      });
    },

    MainApp.prototype.initComponents = function() {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="popover"]').popover();
    },

    //full screen
    MainApp.prototype.initFullScreen = function() {
      var $this = this;
      $this.$btnFullScreen.on('click', function(e) {
        e.preventDefault();

        if (!document.fullscreenElement && /* alternative standard method */
          !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT);
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
        }
      });
    },

    MainApp.prototype.init = function() {
      this.initSlimscroll();
      this.initNavbar();
      this.initActiveMenu();
      this.initComponents();
      this.initFullScreen();
      Waves.init();
    },

    //init
    $.MainApp = new MainApp, $.MainApp.Constructor = MainApp;
}(window.jQuery),

//initializing
  function($) {
    'use strict';
    $.MainApp.init();
  }(window.jQuery);



// WEBPACK FOOTER //
// ./resources/assets/stexo/js/app.js